import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import enquire from "enquire.js";
import { FreeMode } from "swiper";
import { ReactComponent as MenuStar } from "../../components/imgComponents/menu-star.svg";
import "swiper/css/free-mode";
import "../../css/header.scss";
import "swiper/css";

const Header = (props) => {
  const [swiper, setSwiper] = useState();

  let swiperArgs = {
    modules: [FreeMode],
    slidesPerView: "auto",
    freeMode: true,
    slideToClickedSlide: true,
    allowTouchMove: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
  };

  const MobileMenu = () => (
    <Swiper className="swiper-container" {...swiperArgs}>
      <SwiperSlide>
        <NavLink to="/">Home</NavLink>
      </SwiperSlide>
      <SwiperSlide>
        <NavLink to="/before">
          <MenuStar />
          Before BFCM <span className="date">{props.before_page_dates}</span>
        </NavLink>
      </SwiperSlide>
      <SwiperSlide>
        <NavLink to="/during">
          <MenuStar />
          During BFCM <span className="date">{props.during_page_dates}</span>
        </NavLink>
      </SwiperSlide>
      <SwiperSlide>
        <NavLink to="/after">
          <MenuStar />
          After BFCM <span className="date">{props.after_page_dates}</span>
        </NavLink>
      </SwiperSlide>
    </Swiper>
  );

  useEffect(() => {
    enquire.register(`(max-width:767px)`, {
      match: function () {
        setSwiper(true);
      },
      unmatch: function () {
        setSwiper(false);
      },
    });
  }, [swiper]);

  useEffect(() => {
    let location = window.location.href.split("/").pop();

    if (location.indexOf("during") > -1) {
      location = "during";
    } else if (location.indexOf("after") > -1) {
      location = "after";
    } else if (location.indexOf("before") > -1) {
      location = "before";
    } else if (location.indexOf("lp") > -1) {
      location = "lp";
    } else {
      location = "home";
    }

    document.getElementById("bfcm-header").className = location + " header-production";
  }, []);

  const handleClassName = (e) => {
    const link = e.target.href.split("/");
    let location = link[link.length - 1];
    if (location === "") {
      location = "home";
    }
    document.getElementById("bfcm-header").className = location + " header-production";
  };

  return (
    <nav
      id="bfcm-header"
      onClick={(e) => {
        e.preventDefault();
        handleClassName(e);
      }}
    >
      {swiper && <MobileMenu />}
    </nav>
  );
};

export default Header;
